import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/product.svg';

export const IconProduct = createIconComponent(Icon);
